export interface PrivacyLink {
  labelKey: string;
  url: string;
}

export interface HelpLink {
  descriptionKey: string;
  linkLabelKey: string;
  target: string;
  type: 'url' | 'email';
}

/**
 * Spec 097-footer-help-revamp: support contacts moved out of the footer into
 * the Help panel. The data shape is unchanged; we expose `ContactLink` as a
 * readability alias for consumers in the Help panel context.
 */
export type ContactLink = HelpLink;

export interface FooterConfig {
  privacyLinks: PrivacyLink[];
  helpLinks: HelpLink[];
}

/**
 * Maps region API help-link names to Help-panel Contacts i18n keys.
 * Any region help link whose `name` is listed here will be
 * rendered with the corresponding translation keys; unrecognised
 * names are silently skipped (the static config provides fallbacks).
 */
export const REGION_HELP_LINK_KEYS: Record<
  string,
  { descriptionKey: string; linkLabelKey: string }
> = {
  'BOOKING-TOOL-SUPPORT': {
    descriptionKey: 'helpPanel.contacts.noramSupportDescription',
    linkLabelKey: 'helpPanel.contacts.noramSupportLink',
  },
};

export const footerConfig: FooterConfig = {
  privacyLinks: [
    {
      labelKey: 'footer.privacyLinks.privacyStatement',
      url: 'https://www.microsoft.com/en-us/privacy/data-privacy-notice',
    },
    {
      labelKey: 'footer.privacyLinks.legalNotice',
      url: 'https://microsoft.sharepoint.com/sites/hrweb/sitepages/legal-notice.aspx',
    },
  ],
  helpLinks: [
    {
      descriptionKey: 'helpPanel.contacts.noramSupportDescription',
      linkLabelKey: 'helpPanel.contacts.noramSupportLink',
      target: 'noramgemsupport@microsoft.com',
      type: 'email',
    },
    {
      descriptionKey: 'helpPanel.contacts.employeeSupportDescription',
      linkLabelKey: 'helpPanel.contacts.employeeSupportLink',
      target:
        'https://microsoft.sharepoint.com/sites/TechWeb/SitePages/Support/Global-Support-GetTechSupport.aspx',
      type: 'url',
    },
  ],
};
